import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { generateUUID } from 'src/ep-utils';
import { DropdownValue } from '../../dropdown.component';

@Component({
    standalone: false,
    selector: 'ep-radio-group',
    template: `
    <div *ngIf="!hasParentWrapper; else contentTemplate" class="unity-form-group radio">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <ng-template #contentTemplate>
      <div class="unity-input-group" [class.focus]="hasFocus">
        <ng-container *ngFor="let option of codeValues">
          <label>
            <input
              type="radio"
              [name]="radioGroupID"
              [value]="option.Code"
              [(ngModel)]="value"
              (click)="value = option.Code"
              [disabled]="controlDisabled"
              (ngModelChange)="onTouchedCallback()"
            />{{ option.Code_Desc }}
          </label>
        </ng-container>
      </div>
    </ng-template>
  `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RadioGroupComponent),
            multi: true
        }
    ]
})
export class RadioGroupComponent implements ControlValueAccessor {
    @Input()
    codeValues: DropdownValue[] = [];

    @Input()
    selectedValue: string = null;

    @Input()
    align: string = 'left';

    @Input('disabled')
    controlDisabled: boolean = false;

    @Output() blur = new EventEmitter();

    @Output() focus = new EventEmitter();

    @Input()
    hasParentWrapper: boolean = false;

    hasFocus = false;

    innerValue: any = '';

    radioGroupID = 'radiogroup';

    constructor(private cdRef: ChangeDetectorRef) {
        this.radioGroupID = 'radiogroup' + generateUUID();
    }

    isValueSelected(code: string) {
        if (this.value == null || code == null) {
            return false;
        }
        if (this.value == code) {
            return true;
        }
        return false;
    }

    clickTest() {
        console.log('Clicked');
    }

    //***** BEGIN CONTROL VALUE ACCESSOR HANDLERS *****//

    //Placeholders for the callbacks which are later provided by the Control Value Accessor
    private onChangeCallback = (_: any) => { };
    private onTouchedCallback = () => { };

    //get accessor
    get value(): string {
        return this.innerValue;
    }

    //set accessor including call the onchange callback
    set value(v: string) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
    }

    //From ControlValueAccessor interface - Allows Angular to update the model
    writeValue(value: string): void {
        this.innerValue = value;
        this.cdRef.detectChanges();
    }

    //From ControlValueAccessor interface - Allows Angular to register a function to call when the model changes.
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface -  Allows Angular to register a function to call when the input has been touched.
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    //From ControlValueAccessor interface -  Allows Angular to disable the input.
    setDisabledState(isDisabled: boolean): void {
        this.controlDisabled = isDisabled;
    }

    //***** END CONTROL VALUE ACCESSOR HANDLERS *****//
}
